/**
 * Set by useLogout right before it clears the session and sends the browser to
 * Auth0's /v2/logout. Until the browser leaves, the app must not start a
 * navigation of its own: the cleared storage reads as an expired session (exp 0),
 * so the request interceptor in App.tsx reloaded to /, SecuredRoutes sent the
 * user to /login, and the login page started a new sign-in as it rendered. Any of
 * those replaced the trip to Auth0, so the Auth0 session was never ended and the
 * new sign-in went straight through: Logout put the user back in.
 *
 * Module state on purpose: it ends with the page, so the login page the user
 * comes back to after Auth0 works as usual.
 */
let loggingOut = false;

export const markLoggingOut = () => {
  loggingOut = true;
};

export const isLoggingOut = () => loggingOut;
